import React, { useState } from 'react';
import { toast } from 'sonner';
import { Image as ImageIcon } from 'lucide-react';
import { documentsAPI } from '../../lib/api';
import { PhotoLightbox } from '../PhotoLightbox';

const API = process.env.REACT_APP_BACKEND_URL;

export const CardCover = ({ opportunity, onChanged }) => {
    const [photos, setPhotos] = useState([]);
    const [index, setIndex] = useState(null);

    if (!opportunity.cover_thumb_url) return null;

    const open = async (e) => {
        e.stopPropagation();
        try {
            const { data } = await documentsAPI.list(opportunity.id);
            const imgs = data.filter(d => d.thumb_url);
            setPhotos(imgs);
            setIndex(Math.max(0, imgs.findIndex(d => d.is_cover)));
        } catch { toast.error('Impossibile aprire le foto'); }
    };

    const setCover = async (photo) => {
        try {
            await documentsAPI.setCover(photo.id);
            setPhotos(photos.map(p => ({ ...p, is_cover: p.id === photo.id })));
            toast.success('Copertina impostata');
            onChanged?.();
        } catch { toast.error('Errore nell\'impostare la copertina'); }
    };

    return (
        <>
            <button
                type="button"
                onClick={open}
                className="relative h-12 w-12 shrink-0 overflow-hidden rounded-sm border bg-muted hover:ring-2 hover:ring-primary/40 transition-shadow flex items-center justify-center"
                title="Apri le foto"
                data-testid={`card-cover-${opportunity.id}`}
            >
                <ImageIcon size={18} className="text-muted-foreground" />
                <img src={`${API}${opportunity.cover_thumb_url}`} alt="" loading="lazy" className="absolute inset-0 w-full h-full object-cover" onError={(e) => { e.currentTarget.style.display = 'none'; }} />
            </button>
            <div onClick={(e) => e.stopPropagation()}>
                <PhotoLightbox photos={photos} index={index} onIndex={setIndex} onClose={() => setIndex(null)} onSetCover={setCover} />
            </div>
        </>
    );
};
